import {
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Button,
  Col,
  Row
} from "reactstrap";
// import TextEditor from "components/editor/TextEditor";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import { httpRequest } from "utils/httpRequest";

const ChapterDetails = () => {

  const [responseData, setResponseData] = useState(null)

  const { id } = useParams()
  // Formik validation schema
  const validationSchema = Yup.object().shape({
    title: Yup.string()
      .required("Chapter title is required")
      .min(3, "Title must be at least 3 characters"),
    description: Yup.string()
      .required("Chapter description is required")
      .test(
        "min-length",
        "Description must be at least 10 characters (excluding HTML)",
        (value) => {
          if (!value) return false;
          const strippedText = value.replace(/<[^>]*>/g, ""); // Remove HTML tags
          return strippedText.length >= 10;
        }
      )
  });

  const formik = useFormik({
    initialValues: {
      title: "",
      description: ""
    },
    validationSchema,
    onSubmit: (values) => {

      // Handle form submission here
    }
  });



  const getchapterDetails = async () => {
    try {

      const response = await httpRequest(
        `chapter/get/${id}`,
        "GET",
        {},
        {},
        true,
        false
      );
      if (response?.code === 200) {

        setResponseData(response?.data)


      }

    } catch (error) {
      console.log(error);
    }
  }




  useEffect(() => {
    if (id) {
      getchapterDetails()
    }

  }, [id])








  return (
    <Row className="mt-4 justify-content-center">
      <Col lg="8" md="8" className="mx-auto mt-4">
        <Card className="bg-secondary shadow border-0">
          <CardHeader className="bg-transparent pb-3">
            <div className="text-muted text-center mt-2 mb-3">
              <small>View Chapter</small>
            </div>
          </CardHeader>
          <CardBody className="px-lg-5 py-lg-4">
            <Form onSubmit={formik.handleSubmit}>
              <FormGroup className="mb-3">
                <label className="form-control-label">{responseData?.title}</label>
                {/* <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-book-bookmark" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Chapter Title"
                    type="text"
                    name="title"
                    value={formik.values.title}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </InputGroup>
                {formik.touched.title && formik.errors.title && (
                  <div className="text-danger small mt-1">
                    {formik.errors.title}
                  </div>
                )} */}
              </FormGroup>

              <FormGroup>
                <label className="form-control-label" >Chapter Details</label>
                {/* <TextEditor
                  value={formik.values.description}
                  onChange={(html) =>
                    formik.setFieldValue("description", html)
                  }
                  onBlur={() => formik.setFieldTouched("description", true)}
                  placeholder="Chapter Description..."
                  hideImageAndLink={true}
                />
                {formik.touched.description && formik.errors.description && (
                  <div className="text-danger small mt-1">
                    {formik.errors.description}
                  </div>
                )} */}
                <div className="book-description">
                  <p dangerouslySetInnerHTML={{ __html: responseData?.content }}></p>
                </div>
              </FormGroup>

              {/* <div className="text-center">
                <Button className="my-4" color="primary" type="submit">
                  Save Chapter
                </Button>
              </div> */}
            </Form>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default ChapterDetails;